import AddShoppingCartTwoToneIcon from '@mui/icons-material/AddShoppingCartTwoTone'
import ArrowBackTwoToneIcon from '@mui/icons-material/ArrowBackTwoTone'
import AssistantDirectionTwoToneIcon from '@mui/icons-material/AssistantDirectionTwoTone'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import FolderOpenTwoToneIcon from '@mui/icons-material/FolderOpenTwoTone'
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Divider,
    Fab,
    Grid,
    Pagination,
    Stack,
    Typography,
    useMediaQuery
} from '@mui/material'
import 'moment/locale/it'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { GenericListItems } from '../../components/GenericListItem'
import { FormatDataDoc, FormatDataOraRichiesta } from '../fatta/Fatta'
import { GenericQueryPagination, useDuplicateCarrelloAppoggioMutation, useGetCarrelloTestataAppoggioQuery } from '../ricerca/ricercaAPI'
import { CarrelloTestataAppoggioObj, PAGE_SIZE, PAGE_START } from '../ricerca/ricercaSlice'
import { Images } from './Images'

const AppReq3HypservList = GenericListItems<CarrelloTestataAppoggioObj>()

export function Inviati() {
    const navigate = useNavigate()

    const defaultDataSearch: GenericQueryPagination = {
        search: '',
        pageSize: PAGE_SIZE,
        page: PAGE_START,
        filter: null,
        history: false,
        listino: false,
    }

    const [dataSearch, setDataSearch] = useState<GenericQueryPagination>(defaultDataSearch)

    // PAGINATION

    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        const page = value - 1
        setDataSearch((prevData) => {
            return { ...prevData, page }
        })
    }

    const { data, isLoading } = useGetCarrelloTestataAppoggioQuery({
        ...dataSearch,
    })

    // DESIGN

    const [
        duplicate, // This is the mutation trigger
    ] = useDuplicateCarrelloAppoggioMutation()

    const handleClick = (cta: CarrelloTestataAppoggioObj) => {
        duplicate({
            RIF_CLI_NR: cta.RIF_CLI_NR,
        })
        navigate('/carrello')
    }

    const matchesVH = useMediaQuery((theme: any) => theme.breakpoints.only('xs')) == true ? 'none' : 'visible'

    // Aggiungi uno stato per tracciare l'Accordion aperto
    const [openAccordion, setOpenAccordion] = useState<string | null>(null)

    // Aggiungi una funzione per gestire il cambiamento dell'Accordion
    const handleAccordionChange = (RIF_CLI_NR: string) => {
        setOpenAccordion((prevAccordion) => (prevAccordion === RIF_CLI_NR ? null : RIF_CLI_NR))
    }

    return (
        <Box sx={{ pb: 12 }}>
            <AppReq3HypservList
                isLoading={isLoading}
                data={data?.data}
                render={(carrelloTestataAppoggio) => {
                    return (
                        <Accordion
                            key={carrelloTestataAppoggio.RIF_CLI_NR}
                            sx={{ width: '100%', p: 1 }}
                            elevation={5}
                            expanded={openAccordion === carrelloTestataAppoggio.RIF_CLI_NR}
                            onChange={(event: React.SyntheticEvent, expanded: boolean) => {
                                if (carrelloTestataAppoggio.RIF_CLI_NR != null) {
                                    handleAccordionChange(carrelloTestataAppoggio.RIF_CLI_NR)
                                }
                            }}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Grid container direction="column">
                                    <Grid item xs="auto">
                                        <Stack direction="row" spacing={2}>
                                            <Typography variant="button">
                                                {FormatDataDoc(carrelloTestataAppoggio)}
                                            </Typography>
                                            <Typography variant="caption" color="text.secondary">
                                                (art.{' '}
                                                {carrelloTestataAppoggio != null &&
                                                    carrelloTestataAppoggio?.carrelloAppoggioList != null &&
                                                    (carrelloTestataAppoggio?.carrelloAppoggioList?.length).toString()}
                                                )
                                            </Typography>
                                        </Stack>
                                    </Grid>
                                    <Grid item xs="auto">
                                        <Stack direction="column">
                                            <Stack direction="row" gap={2} justifyContent="flex-end">
                                                <AssistantDirectionTwoToneIcon color="primary" />
                                                <Typography variant="body1" sx={{ fontStyle: 'oblique' }}>
                                                    {carrelloTestataAppoggio.DES_DEST_MERCE}
                                                </Typography>
                                            </Stack>
                                            <Stack direction="row" gap={2} justifyContent="flex-end">
                                                <Typography align="right">
                                                    {carrelloTestataAppoggio.INDI_DEST_MERCE}
                                                </Typography>
                                                <Typography align="right">
                                                    {carrelloTestataAppoggio.CAP_DEST_MERCE}
                                                </Typography>
                                            </Stack>
                                            <Stack direction="row" gap={2} justifyContent="flex-end">
                                                <Typography align="right">
                                                    {carrelloTestataAppoggio.COMUNE_DEST_MERCE}
                                                </Typography>
                                                <Typography align="right">
                                                    {carrelloTestataAppoggio.PROVINCIA_DEST_MERCE}
                                                </Typography>
                                            </Stack>
                                            <Stack direction="row" gap={2} justifyContent="flex-end">
                                                <Typography align="right">
                                                    {carrelloTestataAppoggio.STATO_DEST_MERCE}
                                                </Typography>
                                                <Typography align="right">
                                                    {carrelloTestataAppoggio.TEL_DEST_MERCE}
                                                </Typography>
                                            </Stack>
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container alignItems="center">
                                    <Grid item xs={12} textAlign="center" mb={1}>
                                        <Stack direction="row" spacing={1}>
                                            <Typography variant="caption" style={{ fontStyle: 'italic' }}>
                                                Consegna :
                                            </Typography>
                                            <Typography textAlign="center" variant="body1">
                                                {FormatDataOraRichiesta(carrelloTestataAppoggio)}
                                            </Typography>
                                            <Typography variant="body1" textAlign="center">
                                                {carrelloTestataAppoggio.TEMPO_CONSEGNA}
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row" spacing={1}>
                                            <Typography variant="caption" style={{ fontStyle: 'italic' }}>
                                                Note:
                                            </Typography>
                                            <Typography textAlign="center" variant="body1">
                                                {carrelloTestataAppoggio.NOTE_STAMPA || '-'}
                                            </Typography>
                                        </Stack>
                                        <Divider sx={{ mb: 2 }} />
                                        <Button
                                            onClick={() => {
                                                handleClick(carrelloTestataAppoggio)
                                            }}
                                            variant="contained"
                                            endIcon={<AddShoppingCartTwoToneIcon />}
                                        >
                                            Utilizza questo carrello
                                        </Button>
                                    </Grid>
                                    {carrelloTestataAppoggio.carrelloAppoggioList?.map((item) => (
                                        <Box key={item.COD_ART + item.COD_LIST} sx={{ width: '100%' }}>
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="flex-start"
                                                alignItems="center"
                                                alignContent="center"
                                                wrap="nowrap"
                                                spacing={1}
                                            >
                                                <Grid item xs="auto">
                                                    <FolderOpenTwoToneIcon fontSize="small" />
                                                </Grid>
                                                <Grid item xs="auto">
                                                    <Typography variant="caption" color="text.secondary">
                                                        {item.DES_CAT}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs>
                                                    <div style={{ width: '100%' }}>
                                                        <Divider orientation="horizontal" />
                                                    </div>
                                                </Grid>
                                            </Grid>
                                            <Stack direction="row">
                                                {<Images _COD_ART={item.COD_ART} matchesVH={matchesVH} />}
                                                <Grid container ml={2} justifyContent="space-between">
                                                    <Grid item xs={10}>
                                                        <Typography variant="body2">{item.DES_RIGA}</Typography>
                                                    </Grid>
                                                    {item.WEB_DISABILITATO != 1 ? (
                                                        <Grid item xs={2}>
                                                            <Typography variant="body2" textAlign="right">
                                                                {item.QUANT_RIGA} {item.UM}
                                                            </Typography>
                                                        </Grid>
                                                    ) : (
                                                        <Grid item xs={2} textAlign="end">
                                                            <Typography variant="body1" color="error">
                                                                NON DISPONIBILE
                                                            </Typography>
                                                        </Grid>
                                                    )}
                                                    <Grid item xs={12}>
                                                        <Stack direction="row" spacing={1}>
                                                            <Typography
                                                                variant="caption"
                                                                style={{ fontStyle: 'italic' }}
                                                            >
                                                                Note di riga:
                                                            </Typography>
                                                            <Typography textAlign="center" variant="body1">
                                                                {item.NOTE || '-'}
                                                            </Typography>
                                                        </Stack>
                                                    </Grid>
                                                </Grid>
                                            </Stack>
                                        </Box>
                                    ))}
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                    )
                }}
            />
            <Stack alignItems={'center'} spacing={2} sx={{ marginTop: 2 }}>
                <Pagination
                    sx={{ alignItems: 'center', justifyContent: 'center', display: 'flex', width: '100%' }}
                    size="large"
                    variant="outlined"
                    shape="rounded"
                    unselectable="off"
                    color="primary"
                    count={data == null ? 0 : Math.round(data.rowCount / PAGE_SIZE) + 1}
                    page={dataSearch.page + 1}
                    onChange={handleChange}
                />
            </Stack>
            <Box
                sx={{
                    position: 'fixed',
                    bottom: 16,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    mb: 2,
                }}
            >
                <Fab color="primary" aria-label="back" onClick={() => navigate(-1)}>
                    <ArrowBackTwoToneIcon />
                </Fab>
            </Box>
        </Box>
    )
}
